module.exports = __webpack_public_path__ + "static/media/NewYork2.d80b9d0e.jpeg";